/**
 * @generated SignedSource<<f571af16fea118ad0f8e6f16e28e7b2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RootCommentQuery$variables = {
  commentCount: number;
  influencerId: string;
  postCount: number;
  postId: string;
};
export type RootCommentQuery$data = {
  readonly commentReadTimeTotal: {
    readonly unreadTotalComments: number;
  };
  readonly post: {
    readonly " $fragmentSpreads": FragmentRefs<"ChatPagination" | "ChatPost">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"TodosPagination">;
};
export type RootCommentQuery = {
  response: RootCommentQuery$data;
  variables: RootCommentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "influencerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postCount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postId"
},
v4 = {
  "kind": "Variable",
  "name": "influencerId",
  "variableName": "influencerId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "postCount"
  },
  (v4/*: any*/)
],
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "postId"
  }
],
v7 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "commentCount"
  }
],
v8 = [
  (v4/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadTotalComments",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "draftedAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentMediaType",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "file",
  "storageKey": null
},
v16 = [
  (v15/*: any*/),
  (v10/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Banner",
  "kind": "LinkedField",
  "name": "banners",
  "plural": true,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postStartOn",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "castEndAt",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "action",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "attachments",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentType",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RootCommentQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "FragmentSpread",
        "name": "TodosPagination"
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Post",
        "kind": "LinkedField",
        "name": "post",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChatPost"
          },
          {
            "args": (v7/*: any*/),
            "kind": "FragmentSpread",
            "name": "ChatPagination"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "CommentReadTimeTotal",
        "kind": "LinkedField",
        "name": "commentReadTimeTotal",
        "plural": false,
        "selections": [
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RootCommentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "PostConnection",
        "kind": "LinkedField",
        "name": "posts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PostEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Post",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Campaign",
                    "kind": "LinkedField",
                    "name": "campaign",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SocialNetwork",
                        "kind": "LinkedField",
                        "name": "socialNetwork",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "lastComment",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentReadTime",
                    "kind": "LinkedField",
                    "name": "influencerCommentReadTime",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "readableId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unreadCommentCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "filters": [
          "influencerId"
        ],
        "handle": "connection",
        "key": "TodosList_posts",
        "kind": "LinkedHandle",
        "name": "posts"
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Post",
        "kind": "LinkedField",
        "name": "post",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Campaign",
            "kind": "LinkedField",
            "name": "campaign",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gifting",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "prType",
                "storageKey": null
              },
              (v13/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MCategory",
                "kind": "LinkedField",
                "name": "mCategory",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SocialNetwork",
                "kind": "LinkedField",
                "name": "socialNetwork",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postEndOn",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mediaType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasDelivery",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasExperienceGift",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v12/*: any*/),
          (v25/*: any*/),
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "CommentConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stamp",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "extraInfo",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "extraType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Actor",
                        "kind": "LinkedField",
                        "name": "commentable",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "userType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Avatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Ogp",
                        "kind": "LinkedField",
                        "name": "ogps",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "image",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Post",
                        "kind": "LinkedField",
                        "name": "post",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              (v24/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "Chat_comments",
            "kind": "LinkedHandle",
            "name": "comments"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "CommentReadTimeTotal",
        "kind": "LinkedField",
        "name": "commentReadTimeTotal",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3556a833a2696df70e10222bc77cd1fd",
    "id": null,
    "metadata": {},
    "name": "RootCommentQuery",
    "operationKind": "query",
    "text": "query RootCommentQuery(\n  $influencerId: ID!\n  $postId: ID!\n  $postCount: Int!\n  $commentCount: Int!\n) {\n  ...TodosPagination_15DPat\n  post(id: $postId) {\n    ...ChatPost\n    ...ChatPagination_3YJcYQ\n    id\n  }\n  commentReadTimeTotal(influencerId: $influencerId) {\n    unreadTotalComments\n    id\n  }\n}\n\nfragment ChatActionPost on Post {\n  id\n  status\n  draftedAt\n  campaign {\n    prType\n    parentMediaType\n    socialNetwork {\n      postStartOn\n      postEndOn\n      castEndAt\n      id\n    }\n    id\n  }\n}\n\nfragment ChatCampaign on Post {\n  campaign {\n    id\n    title\n    gifting\n    prType\n    parentMediaType\n    status\n    mCategory {\n      name\n      id\n    }\n    banners {\n      file\n      id\n    }\n  }\n}\n\nfragment ChatMessage on Comment {\n  content\n  action\n  stamp\n  extraInfo\n  extraType\n  createdAt\n  commentable {\n    userType\n    avatar {\n      file\n      id\n    }\n    id\n  }\n  ogps {\n    id\n    title\n    image\n    url\n    description\n  }\n  attachments {\n    id\n    file\n    duration\n    contentType\n  }\n  post {\n    id\n  }\n}\n\nfragment ChatPagination_3YJcYQ on Post {\n  comments(first: $commentCount) {\n    edges {\n      node {\n        id\n        ...ChatMessage\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ChatPost on Post {\n  id\n  campaign {\n    id\n    title\n  }\n  ...ChatCampaign\n  ...ChatActionPost\n  ...ChatReportProductReceivedPost\n  ...ChatPostData\n  ...ChatStatus\n}\n\nfragment ChatPostData on Post {\n  id\n  attachments {\n    id\n    file\n    duration\n    contentType\n  }\n}\n\nfragment ChatReportProductReceivedPost on Post {\n  id\n}\n\nfragment ChatStatus on Post {\n  status\n  campaign {\n    prType\n    mediaType\n    hasDelivery\n    hasExperienceGift\n    id\n  }\n}\n\nfragment TodoCampaign on Post {\n  draftedAt\n  status\n  campaign {\n    parentMediaType\n    title\n    banners {\n      file\n      id\n    }\n    socialNetwork {\n      postStartOn\n      castEndAt\n      id\n    }\n    id\n  }\n}\n\nfragment TodoComments on Post {\n  lastComment {\n    content\n    action\n    id\n  }\n  influencerCommentReadTime {\n    id\n    readableId\n    unreadCommentCount\n  }\n}\n\nfragment TodosPagination_15DPat on Query {\n  posts(first: $postCount, influencerId: $influencerId) {\n    edges {\n      node {\n        id\n        status\n        ...TodoCampaign\n        ...TodoComments\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "781c24a483e626179e56d4386ddefa08";

export default node;
